// =============================================================================
// Reviews.io PDP — dynamic header stars
// Reads the aggregate rating from the Polaris widget DOM once it renders and
// injects matching full / half / empty SVG stars into .reviewsio-pdp__stars.
// No API call needed — the rating is already in the widget's aria-label.
// =============================================================================

const STAR_POINTS =
  '8.5,0.5 10.38,5.91 16.11,6.03 11.54,9.49 13.20,14.97 8.5,11.7 3.80,14.97 5.46,9.49 0.89,6.03 6.62,5.91';

function starSVG(type, index) {
  const attrs =
    'xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" focusable="false" aria-hidden="true"';

  if (type === 'full') {
    return `<svg ${attrs}><polygon points="${STAR_POINTS}" fill="currentColor"/></svg>`;
  }

  if (type === 'half') {
    const id = `reviewsio-hdr-half-${index}`;
    return (
      `<svg ${attrs}>` +
      `<defs><clipPath id="${id}"><rect x="0" y="0" width="8.5" height="17"/></clipPath></defs>` +
      `<polygon points="${STAR_POINTS}" fill="none" stroke="currentColor" stroke-width="1.5"/>` +
      `<polygon points="${STAR_POINTS}" fill="currentColor" clip-path="url(#${id})"/>` +
      `</svg>`
    );
  }

  // empty
  return `<svg ${attrs}><polygon points="${STAR_POINTS}" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>`;
}

function renderStars(container, rating) {
  let html = '';
  for (let i = 1; i <= 5; i++) {
    if (rating >= i) {
      html += starSVG('full', i);
    } else if (rating >= i - 0.5) {
      html += starSVG('half', i);
    } else {
      html += starSVG('empty', i);
    }
  }
  container.innerHTML = html;
  container.setAttribute('aria-label', `${rating.toFixed(1)} out of 5 stars`);
  container.setAttribute('role', 'img');
}

function parseRating(widget) {
  // Primary: aggregate aria-label "Overall product rating out of 5: 4.50"
  const ratingEl = widget.querySelector('[aria-label*="out of 5:"]');
  if (ratingEl) {
    const match = ratingEl
      .getAttribute('aria-label')
      .match(/out of 5:\s*([\d.]+)/);
    if (match) return parseFloat(match[1]);
  }

  // Fallback: big heading text content (e.g. "4.50")
  const headingEl = widget.querySelector('.R-TextHeading--md');
  if (headingEl) {
    const val = parseFloat(headingEl.textContent.trim());
    if (!isNaN(val) && val > 0 && val <= 5) return val;
  }

  return null;
}

function reviewsIoPdp() {
  const starsContainer = document.querySelector('.reviewsio-pdp__stars');
  if (!starsContainer) return;

  function tryInject() {
    const widget = document.querySelector('.reviews-io-polaris-widget');
    if (!widget) return false;
    const rating = parseRating(widget);
    if (rating === null) return false;
    renderStars(starsContainer, rating);
    return true;
  }

  // Widget may already be in the DOM (e.g. cached page)
  if (tryInject()) return;

  // Otherwise observe until it renders
  const observer = new MutationObserver(() => {
    if (tryInject()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

export default reviewsIoPdp;
